// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"L3-z","displaySixCardTiles":"M3-z"};